<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter BookTitlePage exclude-print" id="BookTitlePage1"><div class="center"><div class="pc" id="pc1"><img alt="" src="9781455522866_titlepage_online.jpg" style="height: 95%"/></div></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781455522866_booktitlepage.vue?24f35ebe